(function(Togglr) {
    'use strict';

    var Helper = window.Helper || {};

    Togglr.init = function() {
        var items = $('.js-togglr');

        items.each(function() {
            var $self = $(this);

            var $toggle = $self.find('.js-togglr-toggle');
            var $target = $self.find('.js-togglr-target');

            $toggle.on('click', function(event) {
                event.preventDefault();

                if ($self.data('scroll') === true) {
                    Helper.doScroll($self);
                }

                $self.toggleClass('is-active');
                $target.toggleClass('is-hidden');
            });
        });
    };

})(window.Way2web.Togglr = window.Way2web.Togglr || {});
